import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Stack,
  TextField,
  Button,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Collapse,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import { GetCategories, AddCategory, RemoveCategory, UpdateCategory } from '../../utils/categoryAPI';

export default function AdminCategories() {
  const [rows, setRows] = useState([]); // כל הקטגוריות מהשרת
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [openAdd, setOpenAdd] = useState(false);

  //טופס הוספת קטגוריה
  const [categoryType, setCategoryType] = useState('root'); // 'root' | 'child'
  const [name, setName] = useState('');
  const [pathToImeg, setPathToImeg] = useState('');
  const [parentId, setParentId] = useState(null);

  //טופס עריכת קטגוריה
  const [openEdit, setOpenEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editImage, setEditImage] = useState('');

  // פתיחה/סגירה בעץ
  const [openGroups, setOpenGroups] = useState({}); // { [categoryId]: true/false }

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const data = await GetCategories();
      const arr = Array.isArray(data) ? data : [];
      setRows(arr);
      setErr('');
    } catch (e) {
      console.error(e);
      setErr('נכשלה טעינת קטגוריות');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleOpenAdd = () => setOpenAdd(true);

  const handleOpenEdit = (category) => {
  setEditId(category.id);
  setEditName(category.nameCategor || '');
  setEditImage(category.pathToImage || '');
  setOpenEdit(true);
};

  const handleCloseAdd = () => {
    setOpenAdd(false);
    setName('');
    setPathToImeg('');
    setParentId(null);
    setCategoryType('root');
  };

  const handleAdd = async () => {
    try {
      if (!name.trim()) return;

      if (categoryType === 'child' && parentId == null) {
        alert('בחרי קטגוריית אב');
        return;
      }

      const handleEditSave = async () => {
  try {
    await UpdateCategory(editId, {
      nameCategor: editName,
      pathToImage: editImage,
    });

    setOpenEdit(false);
    setEditId(null);

    await fetchCategories();
  } catch (e) {
    console.error(e);
    alert('שגיאה בעדכון קטגוריה');
  }
};

      const payload = {
        nameCategor: name.trim(),
        pathToImage: pathToImeg || null,
        parentCategoryId: categoryType === 'root' ? null : parentId,
      };

      await AddCategory(payload);
      handleCloseAdd();
      await fetchCategories();
    } catch (e) {
      console.error(e);
      alert('שגיאה בהוספת קטגוריה');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('למחוק את הקטגוריה וכל תתי־הקטגוריות שלה?')) return;
    try {
      await RemoveCategory(id);
      await fetchCategories();
    } catch (e) {
      console.error(e);
      alert('שגיאה במחיקה');
    }
  };
  

  const toggleGroup = (id) => {
    setOpenGroups((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // אופציות להורה ב-Select (כולל אינדנטציה)
  const buildParentOptions = (all) => {
    const byParent = new Map();
    all.forEach((c) => {
      const p = c.parentCategoryId ?? null;
      if (!byParent.has(p)) byParent.set(p, []);
      byParent.get(p).push(c);
    });

    const sortByName = (a, b) =>
      (a.nameCategor || '').localeCompare(b.nameCategor || '');
    for (const [, arr] of byParent.entries()) arr.sort(sortByName);

    const out = [];
    const walk = (parent, depth) => {
      const children = byParent.get(parent) || [];
      children.forEach((c) => {
        out.push({ id: c.id, label: `${'— '.repeat(depth)}${c.nameCategor}` });
        walk(c.id, depth + 1);
      });
    };

    walk(null, 0);
    return out;
  };

  // מפה: parentId -> ילדים
  const childrenByParent = useMemo(() => {
    const map = rows.reduce((acc, c) => {
      const key = c.parentCategoryId ?? null; // null לשורשים
      acc[key] = acc[key] || [];
      acc[key].push(c);
      return acc;
    }, {});

    Object.keys(map).forEach((k) => {
      map[k].sort((a, b) =>
        (a.nameCategor || '').localeCompare(b.nameCategor || '')
      );
    });

    return map;
  }, [rows]);

  // קומפוננטה רקורסיבית להצגת העץ
  const CategoryNode = ({ node, depth = 0 }) => {
    const kids = childrenByParent[node.id] || [];
    const isOpen = openGroups[node.id] ?? true;

    return (
      <React.Fragment>
        <ListItem
          sx={{ pl: 2 + depth * 4 }}
          secondaryAction={
            <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(node.id)}>
              <DeleteIcon />
              {/* // עריכה
              <IconButton
                edge="end"
                aria-label="edit"
                onClick={(e) => {
                  e.stopPropagation();
                  setEditId(node.id);
                  setEditName(node.nameCategor);
                  setEditImage(node.pathToImage || '');
                  setOpenEdit(true);
                }}
              >
                ✏️
              </IconButton> */}
            </IconButton>

          }
          button
          onClick={() => {
            if (kids.length > 0) toggleGroup(node.id);
          }}
        >
          <ListItemText
            primary={node.nameCategor}
            secondary={node.pathToImage ? `תמונה: ${node.pathToImage}` : null}
          />
          {kids.length > 0 ? (isOpen ? <ExpandLess /> : <ExpandMore />) : null}
        </ListItem>

        {kids.length > 0 && (
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {kids.map((k) => (
                <CategoryNode key={k.id} node={k} depth={depth + 1} />
              ))}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  return (
    <Box p={3}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          ניהול קטגוריות
        </Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpenAdd}>
          הוספת קטגוריה
        </Button>
      </Stack>

      {loading ? (
        <Stack alignItems="center" py={6}>
          <CircularProgress />
        </Stack>
      ) : err ? (
        <Typography color="error">{err}</Typography>
      ) : (
        <Paper>
          <List>
            {(childrenByParent[null] || []).map((root) => (
              <CategoryNode key={root.id} node={root} depth={0} />
            ))}

            {(childrenByParent[null] || []).length === 0 && (
              <ListItem>
                <ListItemText primary="אין קטגוריות" />
              </ListItem>
            )}
          </List>
        </Paper>
      )}

      {/* דיאלוג הוספה */}
      <Dialog open={openAdd} onClose={handleCloseAdd} fullWidth maxWidth="sm">
        <DialogTitle>הוספת קטגוריה</DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <TextField
              label="שם הקטגוריה"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <TextField
              label="Path To Image (אופציונלי)"
              value={pathToImeg}
              onChange={(e) => setPathToImeg(e.target.value)}
            />

            <FormControl>
              <RadioGroup
                row
                value={categoryType}
                onChange={(e) => {
                  const v = e.target.value;
                  setCategoryType(v);
                  if (v === 'root') setParentId(null);
                }}
              >
                <FormControlLabel value="root" control={<Radio />} label="קטגוריה ראשית" />
                <FormControlLabel value="child" control={<Radio />} label="תת קטגוריה של..." />
              </RadioGroup>
            </FormControl>

            {categoryType === 'child' && (
              <FormControl fullWidth>
                <InputLabel id="parent-category-label">בחרי קטגוריית אב</InputLabel>
                <Select
                  labelId="parent-category-label"
                  label="בחרי קטגוריית אב"
                  value={parentId ?? ''}
                  onChange={(e) => setParentId(Number(e.target.value))}
                >
                  {buildParentOptions(rows).map((opt) => (
                    <MenuItem key={opt.id} value={opt.id}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseAdd}>ביטול</Button>
          <Button variant="contained" onClick={handleAdd} disabled={!name.trim()}>
            שמירה
          </Button>
        </DialogActions>
      </Dialog>
      
    </Box>
  );
}
